import React from "react";

import "./clinicCardDisclaimerTable.css";

const ClinicCardDisclaimerTable = ({
	payFrequency
}: {
	payFrequency?: "MONTHLY" | "WEEKLY" | "BIWEEKLY";
}): JSX.Element => {
	return (
		<div className="disclaimer-table">
			<div className="table-heading">
				<div className="heading-coverage">Coverage</div>
				<div className="heading-premium">Premium Value</div>
			</div>
			{payFrequency === "WEEKLY" ? (
				<div className="table-details-container">
					<div className="table-details">
						<div className="coverage-details">Employee Only</div>
						<div className="premium-details">$11.00 of Weekly Base Pay</div>
					</div>
					<div className="table-details">
						<div className="coverage-details">Employee with Dependents</div>
						<div className="premium-details">$16.00 of Weekly Base Pay</div>
					</div>
				</div>
			) : payFrequency === "MONTHLY" ? (
				<div className="table-details-container">
					<div className="table-details">
						<div className="coverage-details">Employee Only</div>
						<div className="premium-details">$48.00 of Weekly Base Pay</div>
					</div>
					<div className="table-details">
						<div className="coverage-details">Employee with Dependents</div>
						<div className="premium-details">$70.00 of Weekly Base Pay</div>
					</div>
				</div>
			) : null}
		</div>
	);
};

export default ClinicCardDisclaimerTable;
